import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-commercial',
  templateUrl: './commercial.component.html',
  styleUrls: ['./commercial.component.css']
})
export class CommercialComponent implements OnInit {
  listings: any;
  constructor(private httpClient: HttpClient) {}

  ngOnInit(): void {
    this.httpClient.get("/assets/commercial-data/commercial.json").subscribe(data =>{
      // console.log(data);
      this.listings = data;
    });
  }

  getPrice(x) {
    var price = parseInt(x);
    var final_price = '$' + this.numberWithCommas(price);
    return final_price;
  }


  numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  getListingPageID(listing_id) {
    var link = '/listings-com/' + listing_id;
    return link;
  }
}
